<template>
  <div>
    <el-button
      v-for="action in actions"
      :key="action.key"
      size="medium"
      type="primary"
      :disabled="disabled || selectedData.length === 0"
      @click="() => handleClick(action)"
    >
      <span>
        {{ action.name }}
      </span>
    </el-button>
    <UpdateMutiplePopup
      v-if="visible"
      :action="selectedAction"
      :visible="visible"
      :config="config"
      :selected-data="selectedData"
      @reload="() => $emit('reload')"
      @close="visible = false"
    />
  </div>
</template>

<script>
import UpdateMutiplePopup from "@/components/popups/UpdateMutiple.vue";

export default {
  name: "UpdateMutipleButton",
  components: {
    UpdateMutiplePopup,
  },
  props: {
    disabled: Boolean,
    config: Object,
    selectedData: Array
  },
  data() {
    return {
      visible: false,
      selectedAction: null
    };
  },
  computed: {
    actions() {
      return this.config.extra.actions || []
    }
  },
  methods: {
    handleClick(a) {
      this.selectedAction = a
      this.visible = true;
    }
  },
};
</script>

<style lang="scss" scoped></style>
